module.exports = __webpack_public_path__ + "media/components/src/assets/images/arrow-right/arrow-right-08399bd6fa21770d5b61ddd228893f46.svg";